"use client";

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useUserContext } from "@/context/UserContext";

import {
  LayoutDashboard,
  BanknoteArrowUp,
  ListCheck,
  BanknoteArrowDown,
  Fuel,
  Car,
  Smartphone,
  User,
  ListIcon,
  SquarePercent,
  Calendar,
  MapPin,
  DollarSign,
  ChartArea,
  Phone,
} from "lucide-react";
import { useTranslate } from "react-admin";
import { useLocation, NavLink } from "react-router-dom";

export function TaxiDispatch() {
  const {decodedToken} = useUserContext()
  const location = useLocation();
  const translate = useTranslate();

  const data = {
    dispatch: {
      title: "Dispatch",
      navs: [
        {
          name: "Dispatch",
          url: "/",
          icon: LayoutDashboard,
        },
        // {
        //     name: "Dispatch",
        //     url: "/dispatch",
        //     icon: MapIcon,
        // },
        {
          name: translate(`orders.name`, { smart_count: 2 }),
          url: "/taxi-orders",
          icon: ListIcon,
        },
        {
            name: translate(`reservations.name`, { smart_count: 2 }),
            url: "/reservations",
            icon: Calendar,
        },
        {
          name: translate(`report.name`, {smart_count: 2}),
          url: "/reports",
          icon: ChartArea
        },
        (decodedToken?.settings.id === 319 ? {
          name: "Call reports",
          url: "/call-logs",
          icon: Phone
        }: false),

        // KL: Replaced with Destination Rates
        /* {
          name: translate(`fixet_routes.name`, { smart_count: 2 }),
          url: "/fixed-routes",
          icon: Route,
        }, */
        {
          name: "Fixed Rates",
          url: "/route-area-rates",
          icon: DollarSign,
        },
        {
          name: "Destinations",
          url: "/service-locations",
          icon: MapPin,
        },
      ].filter(Boolean),
    },
    management: {
      title: "Management",
      navs: [
        {
          name: translate(`devices.name`, { smart_count: 2 }),
          url: "/devices",
          icon: Smartphone,
        },
        {
          name: translate(`drivers.name`, { smart_count: 2 }),
          url: "/drivers",
          icon: User,
        },
        {
          name: translate(`vehicles.name`, { smart_count: 2 }),
          url: "/vehicles",
          icon: Car,
        },
        {
          name: translate(`clients.name`, { smart_count: 2 }),
          url: "/clients",
          icon: User,
        },
        // {
        //   name: "Notifications",
        //   url: "/clients-notifications",
        //   icon: Bell,
        // },
        {
          name: "Partners",
          url: "/referral-agents",
          icon: SquarePercent,
        },
        {
          name: translate(`refueling.name`, { smart_count: 2 }),
          url: "/refueling",
          icon: Fuel,
        },
        {
          name: translate(`expenses.name`, { smart_count: 2 }),
          url: "/expenses",
          icon: BanknoteArrowDown,
        },
        {
          name: translate(`services.name`, { smart_count: 2 }),
          url: "/service",
          icon: ListCheck,
        },
        {
          name: translate(`incomes.name`, { smart_count: 2 }),
          url: "/incomings",
          icon: BanknoteArrowUp,
        },
      ],
    },
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{data.dispatch.title}</SidebarGroupLabel>
      <SidebarMenu>
        {data.dispatch.navs.map((item) => (
          <SidebarMenuItem
            key={item.name}
            className={`${item.url == location.pathname ? "bg-gray-200 dark:bg-neutral-600 rounded-lg" : ""}`}
          >
            <SidebarMenuButton className="text-[15px] font-medium" asChild>
              <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
      <br />
      <SidebarGroupLabel>
        {data.management.title}
      </SidebarGroupLabel>
      <SidebarMenu>
        {data.management.navs.map((item) => (
          <SidebarMenuItem
            key={item.name}
            className={`${item.url == location.pathname ? "bg-gray-200 dark:bg-neutral-600 rounded-lg" : ""}`}
          >
            <SidebarMenuButton className="text-[15px] font-medium" asChild>
              <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
